import { APIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import { UserIdentity, isUserIdentity } from './userIdentity';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';

import Identity from './identity';
import { headers } from './constants';

/**
 * Redeem a one time access link for a non-refreshable session.
 *
 * @param nonce
 *
 * @returns
 *
 * <details>
 * <summary>
 * On success (resolves)
 * </summary>
 *
 * ```json
 * {
 *   "uuid": "c7e9fed4-bedf-428b-a694-1bbd21721cf7",
 *   "accessToken": "c7e9fed4bedf428b.a6941bbd21721cf7...",
 * }
 * ```
 * </details>
 *
 * <details>
 * <summary>
 * On error (throws)
 * </summary>
 *
 * ```
 * See documentation for corresponding error codes:
 * https://redirector.arcpublishing.com/alc/docs/swagger/?url=./arc-products/arc-identity-v1.json#/Authentication/loginWithMagicLink
 * ```
 * </details>
 */
export default function redeemOTALink(nonce: string): Promise<UserIdentity | APIErrorResponse> {
  return fetch(`${Identity.apiOrigin}/identity/public/v1/auth/magiclink/${nonce}`, {
    method: 'GET',
    headers
  })
    .then(JSONResponseHandler)
    .then(json => {
      if (isUserIdentity(json)) {
        Identity.userIdentity = json;
        return Identity.userIdentity;
      } else {
        throw json;
      }
    });
}
